<template>
  <div>
    <b-row class="d-flex flex-nowrap align-items-end">
      <b-col sm="4" v-show="showComboBanco">
        <b-form-group label="Banco">
          <input-select
            v-model="model.banco"
            @input="loadComboParceiros"
            :options="bancos"
            single
            :required="bancoRequired"
          />
        </b-form-group>
      </b-col>
      <b-col sm="6">
        <b-form-group
          :label="titleComboParceiro ? titleComboParceiro : 'Parceiro'"
        >
          <input-select
            v-model="model.parceiro"
            :options="parceiros"
            placeholder="Todos"
            single
          />
        </b-form-group>
      </b-col>

      <slot name="extraBtns"></slot>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    showComboBanco: { type: Boolean, default: true },
    parceiroSelected: { type: Boolean, default: false },
    value: { type: Object },
    todosParceiros: { type: Boolean, default: false },
    bancoRequired: { type: Boolean, default: true },
    titleComboParceiro: { type: String, default: null }
  },
  data() {
    return {
      bancos: [],
      parceiros: []
    }
  },
  computed: {
    model: {
      get() {
        var obj = this.value
        return obj
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  watch: {
    'model.parceiro': function (val) {
      if (val) {
        let parceiroText = this.parceiros.find(x => x.value === val).text
        this.$set(this.model, 'parceiroText', parceiroText)
      } else {
        this.$set(this.model, 'parceiroText', null)
      }
      this.$emit('refresh')
    }
  },
  methods: {
    loadComboBancos() {
      let th = this

      let dto = {}
      th.$api.Bancos.GetBancosInternos(dto).then(function (data) {
        th.bancos = []
        th.$set(th.model, 'banco', null)
        if (th.$api.UI.PostLoadData(data)) {
          data.forEach(function (item) {
            let banco = {
              value: item.codigo,
              text: item.numero + ' - ' + item.descricao
            }
            th.bancos.push(banco)
          })

          th.$set(
            th.model,
            'banco',
            data.find(e => e.numero === process.env.VUE_APP_BANCO).codigo
          )
        }
      })
    },
    loadComboParceiros() {
      let th = this
      th.$api.Parceiros.GetAll().then(function (response) {
        th.parceiros = []
        th.$set(th.model, 'parceiro', null)
        if (Array.isArray(response)) {
          if (th.todosParceiros) {
            if (!th.parceiros.find(o => o.text === 'Todos' && !!o.value)) {
              th.parceiros.unshift({ value: 0, text: 'Todos' })
            }

            th.$set(th.model, 'parceiro', 0)
          }
          response.forEach(function (item) {
            let parceiro = {
              value: item.codigo,
              text: item.nome.concat(
                ' ',
                '(CNPJ: ',
                th.$api.UI.Format.DocumentoFederal(item.documentoFederal),
                ')'
              )
            }

            th.parceiros.push(parceiro)
          })

          if (th.parceiroSelected) {
            th.$set(th.model, 'parceiro', response[0].codigo)
          }
          th.$emit('obteveParceiros', true)
        }
      })
    },
    refresh() {
      this.$emit('refresh')
    }
  },
  beforeMount: function () {
    this.loadComboBancos()
  }
}
</script>
